module.exports = __webpack_public_path__ + "static/media/team4.8c7d8c1e.jpg";